import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ViewTesting } from '../shared/view-testing.model';
import { ReportsService } from '../shared/reports.service';

@Component({
  selector: 'app-state-test',
  templateUrl: './state-test.component.html',
  styleUrls: ['./state-test.component.scss']
})
export class StateTestComponent implements OnInit, OnChanges {

  displayedColumns: string[] = ['cedula', 'fechaSolicitud', 'idPrueba', 'nomPrueba',
                    'fechaPrueba', 'puntaje', 'entidad', 'estado'];
  dataSource: MatTableDataSource<ViewTesting>;
  messageError: String = '';
  claseMessage: String = 'messaje-error';

  @Input() requests: ViewTesting[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private reporstService: ReportsService) {
    this.setTable();
  }

  ngOnInit() {
    this.setTable();
  }

  private setTable() {
    this.dataSource = new MatTableDataSource(this.requests);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnChanges() {
    this.setTable();
  }

}
